<template>
  <div>
    <!-- :loading="isDownloading" -->
    <v-btn
      small
      :disabled="isDisabled"
      class="extract-btn"
      @click="exportData"
    >
      <v-icon>mdi-download</v-icon> &nbsp;
      {{ dlLabel }}
    </v-btn>
    <v-snackbar v-model="downloadSuccess">
      CSV Downloaded
      <v-btn @click="downloadSuccess = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import { IsJsonString } from '@/utils/helper'

export default {
  props: {
    data: {
      type: Array
    },
    getData: {
      type: Function
    },
    title: {
      type: String
    },
    dlLabel: {
      type: String,
      default: 'Download'
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      downloadSuccess: false
    }
  },
  // computed: {
  //   downloading: {
  //     get: function (){
  //       return this.isDownloading
  //     }
  //   }
  // },
  methods: {
    exportData () {
      // this.downloading = true
      let csvContent = 'data:text/csv;charset=utf-8,'
      let d = new Date()
      let timeAndDateFormat = `${d.getMonth() + 1}-${d.getDate()}-${d.getFullYear()}.${d.getTime()}`
      let fileName = this.title ? `${this.title} - ${timeAndDateFormat}.csv` : `${timeAndDateFormat}.csv`
      let csvData = this.data.length !== 0 ? this.data : this.getData()

      csvContent += [
        Object.keys(csvData[0]).join(',').replace(/_/g, ' '),
        ...csvData.map(item => {
          let account = {}
          for (const key in item) {
            if (item.hasOwnProperty(key)) {
              if (item[key] !== null) {
                if (key === 'Change_From' || key === 'Change_To') {
                  account[key] = `"${item[key].replace(/(\r\n|\n|\r|,|#)/gm, '')}"`
                } else if ( key === 'Marketing Campaign') {
                  account[key] = `"${item[key].replace(/"/g, '')}"`
                } else if (IsJsonString(item[key])) {
                  let jsonObj = JSON.parse(item[key])
                  console.log(jsonObj)
                  if (jsonObj.hasOwnProperty('all')) {
                    account[key] = jsonObj.all
                  } else {
                    account[key] = jsonObj.map(function (record) {
                      if (record && record.hasOwnProperty('email')) {
                        return record.email
                      } else {
                        return record
                      }
                    }).join('; ')
                  }
                } else {
                  account[key] = `"${item[key].replace(/(\r\n|\n|\r|,|#)/gm, '')}"`
                }
              } else {
                account[key] = `"${item[key]}"`
              }
            }
          }
          return Object.values(account).join(',')
        })
      ].join('\n').replace(/(^\[)|(\]$)/gm, '')
      const outputData = encodeURI(csvContent)
      const link = document.createElement('a')
      link.setAttribute('href', outputData)
      link.setAttribute('download', fileName)
      link.click()
      this.$emit('csv-download-success')
      // this.downloading = false
      this.downloadSuccess = true
    }
  }
}
</script>
<style lang="scss">
</style>
